import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { filter, take } from 'rxjs/operators';
import {
    Feature,
    FeatureNames,
    FeaturePropertyKey,
    IsEnabledProperty,
} from '../../../../../../projects/client';
import { InstallationFeaturesStore } from '../../../../../@store';
import { InstallationService } from '../../../../services/installation.service';

@Component({
  selector: 'app-select-channel-modal',
  templateUrl: './select-channel-modal.component.html',
  styleUrls: ['./select-channel-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectChannelModalComponent implements OnInit {
  readonly featurePropertyKey = FeaturePropertyKey;

  allCircuits: Feature<IsEnabledProperty, never>;
  selectedChannel: string = null;

  constructor(
    public installationService: InstallationService,
    private installationFeaturesStore: InstallationFeaturesStore,
    private cdr: ChangeDetectorRef,
    private dialogRef: MatDialogRef<SelectChannelModalComponent>
  ) {}

  ngOnInit(): void {
    this.installationFeaturesStore
      .selectInstallationDeviceFeature(FeatureNames.circuits)
      .pipe(
        filter((entry) => !!entry),
        take(1)
      )
      .subscribe((circuits: Feature<IsEnabledProperty, never>) => {
        this.allCircuits = circuits;
        this.cdr.markForCheck();
      });
  }

  onConfirm(): void {
    // channel == heating circuit id in the OBNG add-actor context.
    this.dialogRef.close({ channel: Number(this.selectedChannel) });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
